import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import api from '../utils/api';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const { user } = useAuth();
  // Persist in localStorage; sync with user preference on login
  const [theme, setThemeState] = useState(() => localStorage.getItem('qp_theme') || 'dark');

  // When user loads, sync their saved theme preference
  useEffect(() => {
    if (user?.theme) {
      setThemeState(user.theme);
      localStorage.setItem('qp_theme', user.theme);
    }
  }, [user?.theme]);

  // Apply theme to <html>
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = async () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setThemeState(next);
    localStorage.setItem('qp_theme', next);
    document.documentElement.setAttribute('data-theme', next);
    // Save to server if logged in
    try { await api.put('/auth/profile', { theme: next }); } catch {}
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
